import { useRpQuery } from '~/composables/graphql'
import { useMutation } from '@tanstack/vue-query'
import type { SignDocumentInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useSelectedLanguage } from '~/composables/use-selected-language'

export function useMembershipSignDocumentMutation() {
    const query = useRpQuery()
    const selectedLanguage = useSelectedLanguage()
    const activeFacility = useActiveFacility()

    return useMutation({
        mutationFn: (mutationData: SignDocumentInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation MembershipSignDocumentMutation(
                        $input: SignDocumentInput!
                        $facilityId: ID!
                        $language: Language!
                    ) {
                        signDocument(input: $input) {
                            __typename
                            ... on SignDocumentResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseMembershipContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    path
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id,
                    language: selectedLanguage.value
                }
            )
    })
}
